module.exports = __webpack_public_path__ + "Roboto-BoldItalic.b37d0bb73a2f688ecaee.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-BoldItalic.ttf
// module id = 382
// module chunks = 2